module.exports = __webpack_public_path__ + "static/media/16.d897379d.jpg";